import {Collapse, Grid} from "@mui/material";
import {useCallback, useState} from "react";
import MhdSelect from "../../atomicComponents/MhdSelect";
import {mapResolutionChoices, vignetteChoices} from "../../../utils/choices";
import MhdInput from "../../atomicComponents/MhdInput";
import WidgetSwitch from "../../atomicComponents/WidgetSwitch";
import {setAndUpdate, validateAndUpdate} from "../../../utils/helpers";
import MhdWidgetDivider from "../../atomicComponents/MhdWidgetDivider";
import MhdSolidColorWidget from "../../atomicComponents/MhdSolidColorWidget";
import MhdColorbarWidget from "../../atomicComponents/MhdColorbarWidget";

const SliceWidget = ({data, mods, warn, errs, update, setter}) => {

  return (
    <Grid container spacing={1}>
      <Grid item xs={6}>
        <MhdSelect
          label="Vignette"
          value={data.vignette_function}
          onChange={useCallback((v) => setAndUpdate("vignette_function", v, setter, update), [])}
          choices={vignetteChoices}
        />
      </Grid>
      <Grid item xs={3}>
        <MhdInput
          label='Radial Power'
          value={data.radial_power}
          override={mods.radial_power}
          warning={warn.radial_power}
          error={errs.radial_power}
          onChange={useCallback((v) => validateAndUpdate("radial_power", v, setter, update), [])}
        />
      </Grid>
      <Grid item xs={3}>
        <WidgetSwitch
          label="Logscale"
          value={data.log_transform}
          onChange={useCallback((v) => setAndUpdate("log_transform", v, setter, update), [])}
        />
      </Grid>
      <Grid item xs={12}>
        <MhdSelect
          label="Map Resolution"
          value={data.resolution}
          override={mods.resolution}
          warning={warn.resolution}
          error={errs.resolution}
          onChange={useCallback((v) => setAndUpdate("resolution", v, setter, update), [])}
          choices={mapResolutionChoices}
        />
      </Grid>
      <Grid item xs={12}>
        <MhdColorbarWidget
          label="Color Palette"
          value={data.color}
          onChange={useCallback((v) => setAndUpdate("color", v, setter, update), [])}
        />
      </Grid>
      <Grid item xs={12}>
        <MhdSolidColorWidget
          label="Occult Color"
          value={data.occult_color}
          onChange={useCallback((v) => setAndUpdate("occult_color", v, setter, update), [])}
        />
      </Grid>
    </Grid>
  );
}

export default SliceWidget;